import React from 'react';
import { useAppSelector } from '../../../../../store/hooks';
import Tag from '../../../../../core/components/tag/Tag';
import { partsKitDetailsHeadSelector } from '../../../../../store/selectors/partsKitSelectors';
import { TruncateTooltip } from '../../../../../common/components/truncate-tooltip/TruncateTooltip';

const PartsKitHead:React.FC = () => {
  const entities = useAppSelector(partsKitDetailsHeadSelector);

  return (
    <>
      {entities.map((ent, i) => <div key={i} className="head__inner-info-item">
        <TruncateTooltip value={ent.label} className="head__inner-info-item__label" />
        {ent.label === 'Status'
          ? <Tag label={ent.value?.toString() || '-'} />
          : <TruncateTooltip className="head__inner-info-item__value" value={ent.value ? ent.value.toString() : '-'} />}
      </div>)}
    </>
  );
};

export default PartsKitHead;
